import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from '@saleshandy/icons';
import { DateTime } from 'luxon';
import { Placement } from '../../../../../../../../shared/design-system/components/overlay';
import { getFormattedDate } from '../../../../../../../settings/components/users-and-teams/utils/get-formatted-date';
import { getUserTimeZone } from '../../../../../../../../shared/utils/user-details';
import TransferOverlayTrigger from '../../../../../../../../shared/design-system/components/transfer';
import { TestReportLastRunList } from '../../../../../../types';

interface IProps {
  testRunOnList: TestReportLastRunList;
  selectedTestId: string;
  onTestIdChange: (testId: string) => void;
  hideTransfer?: boolean;
  lastRunOn?: string;
  showDropdown?: boolean;
}

type Option = {
  id: string;
  activatedAt: string;
  run: string;
};

const TestRunOnDropdown: React.FC<IProps> = ({
  testRunOnList,
  selectedTestId,
  onTestIdChange,
  hideTransfer = false,
  lastRunOn,
  showDropdown = true,
}) => {
  const [show, setShow] = useState(false);

  const handleTestIdChange = (testId: string) => {
    onTestIdChange(testId);
    setShow(false);
  };

  const optionsWithKey = testRunOnList?.map((o) => ({ ...o, key: o.id })) || [];

  const selectedTest = optionsWithKey.find(
    (test) => test.id === selectedTestId,
  );

  // Get the date to display
  const getDisplayDate = () => {
    if (selectedTest) {
      return getFormattedDate(selectedTest.activatedAt, getUserTimeZone());
    }
    if (lastRunOn) {
      return getFormattedDate(lastRunOn, DateTime?.local()?.zoneName);
    }
    return '-';
  };

  return (
    <div className="test-run-on-dropdown-container">
      <span className="test-run-on-dropdown-label">Test Run On:</span>
      {!showDropdown || hideTransfer ? (
        <span className="test-run-on-without-dropdown-btn-value">
          {getDisplayDate()}
        </span>
      ) : (
        <TransferOverlayTrigger<Option>
          show={show}
          onToggle={(value) => setShow(value)}
          className="test-run-on-dropdown"
          showSearch={false}
          options={optionsWithKey}
          selectedOptionKey={[selectedTestId]}
          onChange={(opt) => {
            handleTestIdChange(opt[0].id);
          }}
          optionRenderer={(option) => (
            <span className="test-run-on-dropdown-option">
              {getFormattedDate(option.activatedAt, getUserTimeZone())}
            </span>
          )}
          placement={Placement.BottomStart}
        >
          <div className="test-run-on-dropdown-btn">
            <span className="test-run-on-dropdown-btn-value">
              {getDisplayDate()}
            </span>
            <span>
              {show ? (
                <ChevronUp height={20} width={20} color="#1f2937" />
              ) : (
                <ChevronDown height={20} width={20} color="#1f2937" />
              )}
            </span>
          </div>
        </TransferOverlayTrigger>
      )}
    </div>
  );
};

export default TestRunOnDropdown;
